import { onError, ErrorResponse } from 'apollo-link-error';
import { handleUnauthorized } from '../../authentication';

const errorLink = onError((errors: ErrorResponse) => {
  const { graphQLErrors } = errors;
  if (graphQLErrors) {
    graphQLErrors.forEach(err => {
      const { message, locations, path } = err;
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, err);
    });
  }

  const networkError = errors.networkError as any;
  if (networkError && networkError.statusCode && networkError.statusCode === 401) {
    handleUnauthorized();
    return;
  }

  return;
});

export default errorLink;
